import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDBTeV1PMO196cMcp4YvDP1q-0n_MSk7pE",
  authDomain: "aprovado-6455c.firebaseapp.com",
  projectId: "aprovado-6455c",
  storageBucket: "aprovado-6455c.firebasestorage.app",
  messagingSenderId: "246875015214",
  appId: "1:246875015214:web:fc94e7c0cc65bb3b7d77bf"
};

const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';
const app = initializeApp(useEmulators ? {
  ...firebaseConfig, projectId: 'demo-pruvenx', apiKey: 'fake-api-key',
  authDomain: 'demo-pruvenx.firebaseapp.com'
} : firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  connectFirestoreEmulator(db, '127.0.0.1', 8085);
  connectFunctionsEmulator(getFunctions(app, 'southamerica-east1'), '127.0.0.1', 5001);
}
export default app;
